import {TextField, IconButton} from "@material-ui/core";
import {Clear} from "@material-ui/icons";
import React, {useEffect, useState} from "react";

export default function Field({label, value, updator, styles = {}}) {
  const [currentValue, setValue] = useState((value ?? "").toString());

  useEffect(() => {
    setValue((value ?? "").toString());
  }, [value]);

  return (
    <span
      style={{
        margin: "0.25em 1em",
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",
        maxWidth: "8em",
        ...styles,
      }}
    >
      <TextField
        style={{width: "100%", textTransform: "capitalize"}}
        label={label}
        value={currentValue}
        onChange={event => setValue(event.target.value)}
        onBlur={() => updator(currentValue)}
      />
      {value && (
        <IconButton
          size="small"
          onClick={() => {
            setValue("");
            updator("");
          }}
        >
          <Clear />
        </IconButton>
      )}
    </span>
  );
}
